import type React from 'react'
import { createPortal } from 'react-dom'

interface Props {
  children: React.ReactNode
}
const Portal = ({ children }: Props) => {
  const portalRoot = document.getElementById('root')

  if (!portalRoot) return null
  return createPortal(children, portalRoot)
}

export default Portal
